import React, { useEffect, useState } from 'react';
import fetchAdminAreas from '../api/adminAreas';
import { AdminArea } from '../types';
import AdminAreaListing from './adminAreaListing';

interface Props {
    frontPage: boolean
    code?: string
}

const ClimbingAreasByState = (props: Props) => {

    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [adminAreas, setAdminAreas] = useState<AdminArea[]>([]);

    const { frontPage } = props;

    useEffect(() => {
        fetchAdminAreas(true, frontPage)
        .then(
          (adminAreas) => {
            setIsLoaded(true);
            setAdminAreas(adminAreas);
          },
          (error) => {
            setIsLoaded(true);
            setError(error);
          }
        );
    }, [frontPage]);

    // Show error
    if (error) {
        return <div>Error: (error.message)</div>;
    // Show loading
    } else if (!isLoaded) {
      return <div>Loading...</div>;
    // Show results
    } else {
      const filteredAdminAreas = props.code ? adminAreas.filter(adminArea => adminArea.code == props.code) : adminAreas
      return <AdminAreaListing adminAreas={filteredAdminAreas} frontPage={frontPage} />
    }

};

export default ClimbingAreasByState;